import { combineReducers } from 'redux'
import ScheduleByDateReducer from './schedule.bydate.reducer'
import ScheduleByDoctorReducer from './schedule.bydoctor.reducer'

const ScheduleReducer = combineReducers({
  bydate: ScheduleByDateReducer,
  bydoctor: ScheduleByDoctorReducer,
})

export default ScheduleReducer